import React from 'react'
import { connect } from 'react-redux'
import { bool, func, string } from 'prop-types'
import MdArrowDownward from 'react-icons/lib/md/arrow-downward'
import { toggleSearchContentFooter } from '../../../../store/Actions/UiActions'
import '../styles/smallScreen.css'

const SmallScreenClose = props =>
  props.searchContentFooter &&
  props.online && (
    <div
      className="close-for-small-screen"
      onClick={() => props.toggleSearchContentFooter(false)}
    >
      <MdArrowDownward color={props.theme} />
    </div>
  )

SmallScreenClose.propTypes = {
  toggleSearchContentFooter: func.isRequired,
  searchContentFooter: bool.isRequired,
  theme: string.isRequired,
  online: bool.isRequired,
}

const mapStateToProps = ({ ui, spi }) => ({
  searchContentFooter: ui.searchContentFooter,
  theme: spi.theme,
  online: spi.online,
})

const mapDispatchToProps = dispatch => ({
  toggleSearchContentFooter: value =>
    dispatch(toggleSearchContentFooter(value)),
})

export default connect(mapStateToProps, mapDispatchToProps)(SmallScreenClose)



// WEBPACK FOOTER //
// ./src/components/Elements/SearchContent/CloseSearchContent/smallScreen.jsx